//wakeLock.ts — stops the display sleeping mid-session on a permanently-installed mirror

//The lock is dropped whenever the page is hidden, so it has to be retaken on every return
//to visibility rather than acquired once at startup.
export function keepAwake(): void {
	if (!('wakeLock' in navigator)) return

	let sentinel: WakeLockSentinel | null = null

	const acquire = async () => {
		if (document.visibilityState !== 'visible' || sentinel) return
		try {
			sentinel = await navigator.wakeLock.request('screen')
			sentinel.addEventListener('release', () => {
				sentinel = null
			})
		} catch {
			//Denied without a user gesture on some browsers. Not fatal — the mirror still runs.
		}
	}

	document.addEventListener('visibilitychange', () => void acquire())
	void acquire()
}
